import React from 'react';
import MenuItem from '@mui/material/MenuItem';

interface AccountChangelogMenuItemProps {
  allowChangelog: boolean;
  onOpen: () => void;
}

/** The UI gate only; the API independently enforces the entitlement. */
export default function AccountChangelogMenuItem({
  allowChangelog,
  onOpen,
}: AccountChangelogMenuItemProps) {
  if (!allowChangelog) return null;
  return <MenuItem onClick={onOpen}>What's New</MenuItem>;
}
